import { render, staticRenderFns } from "./SearchPropertys.vue?vue&type=template&id=12e66533"
import script from "./SearchPropertys.vue?vue&type=script&lang=js"
export * from "./SearchPropertys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports